// extracted by mini-css-extract-plugin
export default {"inner":"SpyMenu_inner__Nph-e","opacity":"SpyMenu_opacity__86dOf","link":"SpyMenu_link__GP2B8","active":"SpyMenu_active__V60J0","wrap":"SpyMenu_wrap__VXBuQ"};